import { useCallback } from 'react'

import { SELLER_ID_SAE } from '../../order/model/SELLER_ID_SAE'
import { useExperimentsPageType } from '../components/ExperimentsPageTypeContext'
import {
  EXPERIMENTS_TRACK_EVENT_CLICK_ON_PRODUCT,
  experimentsTrackEvent,
} from '../eventTracking'
import { EXPERIMENT_PAGE_TYPE_SEARCH } from '../ExperimentPageType'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_COMPOSITION_API } from '../model/EXPERIMENT_NAME'

export const useExperimentCompositionApiTracking = (
  sellerId?: string,
): (() => void) => {
  const trackEvent = `${EXPERIMENTS_TRACK_EVENT_CLICK_ON_PRODUCT} ${sellerId === SELLER_ID_SAE ? 'OS' : 'MP'}`

  const { isEnabled } = useGetExperiment(EXPERIMENT_NAME_COMPOSITION_API)
  const pageType = useExperimentsPageType()

  return useCallback((): void => {
    if (!isEnabled || pageType !== EXPERIMENT_PAGE_TYPE_SEARCH) {
      return
    }
    if (sellerId) {
      experimentsTrackEvent(trackEvent)
    }
    experimentsTrackEvent(EXPERIMENTS_TRACK_EVENT_CLICK_ON_PRODUCT)
  }, [isEnabled, trackEvent, pageType, sellerId])
}
